module.exports = __webpack_public_path__ + "img/recommend-21-h5.55c062c6.png";